const linkResolver = require("./linkResolver");

const htmlLinkResolver = (htmlString) => {
  // Match all <a> tags with href attributes using regex
  return htmlString.replace(/<a[^>]*href=["']([^"']+)["'][^>]*>/g, (match, href) => {
    // Replace the href value with resolved link
    const resolvedHref = linkResolver({ url: href });
    return match.replace(href, resolvedHref);
  });
};

module.exports = htmlLinkResolver;
